export default __webpack_public_path__ + "static/media/agen_referral_cara5.72617cf2.svg";